import axios from 'axios';
import { API_ENDPOINTS } from './api';

const LEGACY_INVOICES_KEY = 'zovcur_pharma_invoices';
const LEGACY_MIGRATED_KEY = 'zovcur_invoices_migrated_to_db';

/** Clear any legacy browser invoice cache (invoices are MongoDB-only). */
export const purgeLocalInvoiceStorage = () => {
  localStorage.removeItem(LEGACY_INVOICES_KEY);
  localStorage.removeItem(LEGACY_MIGRATED_KEY);
};

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`
});

export const isMongoInvoiceId = (id) => /^[a-f\d]{24}$/i.test(String(id || ''));

export const fetchAllInvoices = async () => {
  const response = await axios.get(API_ENDPOINTS.getZovcurInvoices, {
    headers: authHeaders()
  });
  return response.data || [];
};

export const fetchInvoiceById = async (id) => {
  const response = await axios.get(API_ENDPOINTS.getZovcurInvoiceById(id), {
    headers: authHeaders()
  });
  return response.data;
};

export const fetchNextInvoiceNumber = async () => {
  const response = await axios.get(API_ENDPOINTS.getNextZovcurInvoiceNumber, {
    headers: authHeaders()
  });
  return response.data?.invoiceNumber || 'Zov001';
};

export const createInvoice = async (invoice) => {
  const response = await axios.post(API_ENDPOINTS.createZovcurInvoice, invoice, {
    headers: authHeaders()
  });
  return response.data;
};

export const updateInvoice = async (id, invoice) => {
  const response = await axios.put(API_ENDPOINTS.updateZovcurInvoice(id), invoice, {
    headers: authHeaders()
  });
  return response.data;
};

export const updateInvoicePayment = async (id, paymentStatus) => {
  const response = await axios.put(
    API_ENDPOINTS.updateZovcurInvoicePayment(id),
    { paymentStatus },
    { headers: authHeaders() }
  );
  return response.data;
};

export const deleteInvoice = async (id) => {
  await axios.delete(API_ENDPOINTS.deleteZovcurInvoice(id), {
    headers: authHeaders()
  });
};
